import './PhoneNumber.scss';
import Component from './PhoneNumber.js';
export default Component;
